<template>
  <div class="alert-wrapper w-100" :id="`${id}-messages`">
    <div v-for="(message, index) in filteredMessages" :key="index">
      <div class="container alert" :class="`alert-${message.type}`" role="alert">
        <span class="icon white" :class="icons[message.type]" /> {{ message.text || $t(message.textKey) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    id: { type: String, default: 'main' },
    limit: { type: Number, default: 1 },
  },
  data: () => ({
    icons: {
      info: 'icon-info3',
      danger: 'icon-error',
      success: 'icon-checkmark-circle gray',
    },
  }),
  computed: {
    ...mapState('alerts', ['messages']),
    filteredMessages() {
      return this.messages.filter((message) => message.target === this.id);
    },
  },
  watch: {
    filteredMessages(messages) {
      messages.slice(this.limit).forEach(this.deleteMessage);
    },
  },
  methods: {
    ...mapActions('alerts', ['deleteMessage']),
  },
  beforeUnmount() {
    this.filteredMessages.forEach(this.deleteMessage);
  },
};
</script>
